module.exports = __webpack_public_path__ + "img/nav-design-vintage.ce54c0f.webp";